import React from 'react';
export const PlusGraph = _ref => {
  let {
    color1 = '#2AB6B9',
    color2 = '#202020',
    size = '16'
  } = _ref;
  return React.createElement("svg", {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M0.648493 0C0.291494 0 0 0.30663 0 0.673253V27.3401C0 27.7067 0.291494 28 0.648493 28H28.8252C29.1855 28 29.4737 27.7034 29.4737 27.3401C29.4737 26.9768 29.1822 26.6668 28.8252 26.6668H1.31009V0.673253C1.31009 0.30663 1.02187 0 0.648493 0Z",
    fill: color1
  }), React.createElement("path", {
    d: "M21.1999 5.89471C20.782 5.89471 20.4854 6.25474 20.4955 6.5606C20.509 6.88877 20.8427 7.18189 21.1999 7.15959H24.9005L15.1065 15.8639C13.8763 14.9049 12.636 13.9332 11.5845 13.0857C11.4531 12.9487 11.2374 12.8722 11.0486 12.8945C10.8936 12.8945 10.7487 12.9614 10.6307 13.0634L3.89692 18.7983C3.63404 19.0118 3.61045 19.4546 3.84974 19.7C4.08903 19.9485 4.54401 19.958 4.80353 19.735L11.0958 14.3729L14.6548 17.1734C14.9042 17.3996 15.3491 17.4092 15.5985 17.1862L25.9149 8.00708V11.6296C25.9014 11.9578 26.2385 12.2732 26.5822 12.2732C26.926 12.2732 27.263 11.9578 27.263 11.6296V6.52556C27.263 6.18783 26.9395 5.89471 26.5822 5.89471H21.1965H21.1999Z",
    fill: color2
  }));
};